<div
  class="container col-sm-8 pt-5 webview text-center pb-5"
  [@flyInOut]="'in'"
>
  <h1 class="text-center font-weight-normal-calibre pb-4 questxt">
    {{ question }}
  </h1>
  <div _ngcontent-c5="" class="col-md-5 col-lg-4 m-auto" id="datepick">
    <div>
      <app-datepicker
        [pickerPlaceholder]="placeholderText"
        [inputValue]="model"
        (selectedItem)="valueChanged($event)"
      ></app-datepicker>
      <!-- <mat-form-field class="example-full-width datePicker" appearance="fill">
        <mat-label>MM/DD/YYYY</mat-label>
        <input
          matInput
          [matDatepicker]="picker"
          [matDatepickerFilter]="myFilter"
          [min]="minDate"
          [max]="maxDate"
          [(ngModel)]="model"
          (ngModelChange)="getDate()"
          disabled
        />
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker disabled="false"></mat-datepicker>
      </mat-form-field> -->
    </div>
  </div>
  <button *ngIf="showbutton" 
    class="btn next mr-2 ml-2 disabledButton mt-4 font22 text-uppercase"
    [ngClass]="{ sectbtn: user_bot }"
    (click)="next()"
  >
    Save
  </button>
</div>
<div class="container mobileview mt-2 px-0" [attr.id]="questionObj._id">
  <div class="d-flex h-100 row col-sm-12 pr-0">
    <div class="justify-content-center align-self-center col-sm-3 col-3 pl-0">
      <img style="width: 100%" src="assets/images/signimg.jpg" />
    </div>
    <div class="col-sm-9 col-9 px-0 my-auto">
      <div class="arrow_box">
        <h1 class="questionMob text-left">{{ question }}</h1>
      </div>
    </div>
  </div>
  <div class="col-12 m-auto">
    <div class="col-9 offset-col-3 mb-2 px-0 pull-right">
      <div class="form-group">
        <app-datepicker
          [pickerPlaceholder]="placeholderText"
          [inputValue]="model"
          (selectedItem)="valueChanged($event)"
        ></app-datepicker>
        <!-- <mat-form-field class="example-full-width" appearance="fill">
          <mat-label>MM/DD/YYYY</mat-label>
          <input
            matInput
            [matDatepickerFilter]="myFilter"
            [matDatepicker]="mobpicker"
            [min]="minDate"
            [max]="maxDate"
            [(ngModel)]="model"
            (ngModelChange)="getDate()"
            disabled
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="mobpicker"
          ></mat-datepicker-toggle>
          <mat-datepicker #mobpicker disabled="false"></mat-datepicker>
        </mat-form-field> -->
      </div>
    </div>
    <div class="clear"></div>
    <div style="width: 97% !important; text-align: right">
      <div *ngIf="user_bot" class="ash_box text-right">
        <h1 class="ansMob text-right">{{ ans_date }}</h1>
      </div>
    </div>
  </div>
</div>
